import * as React from 'react'
import { Paragraph, styled } from 'tamagui'

export type AnchorLinkProps = React.ComponentProps<typeof AnchorLink>
export const AnchorLink = styled(Paragraph, {
  tag: 'a',
  cursor: 'pointer',
  color: '$color11',
  textDecorationLine: 'none',
  tabIndex: -1,
  hoverStyle: {
    color: '$color',
  },
  variants: {
    grid: {
      true: {
        fow: '200',
        ls: 1,
        // textTransform: 'unset',
        w: '100%',
        f: 1,
        p: '$2',
        px: '$4',

        hoverStyle: {
          backgroundColor: 'color-mix(in srgb, var(--color8) 10%, transparent 50%)' as any,
        },
      },
    },
    half: {
      true: {
        maxWidth: '48.5%',
        overflow: 'hidden',
      },
    },
    underlined: {
      true: {
        textDecorationLine: 'underline',
      },
    },
  } as const,
})
